import { z } from "zod";

const marketingAttributionPattern = /^[a-zA-Z0-9._~-]+$/u;

export function marketingAttributionToken<Value>(value: Value): string | undefined {
  const parsed = z.string().safeParse(value);
  if (!parsed.success) return undefined;
  const normalized = parsed.data.trim();
  if (
    !normalized ||
    normalized.length > 80 ||
    !marketingAttributionPattern.test(normalized) ||
    normalized.replaceAll(/\D/gu, "").length >= 7
  ) {
    return undefined;
  }
  return normalized;
}
